import React from 'react';
import { GraduationCap, Users, HandCoins, Building2, Radio, CalendarDays, ArrowRight } from 'lucide-react';

const placeholders = [
  { id: 'ambassadeurs', Icon: Users, label: 'Ambassadeurs', badge: null, title: 'Programme Ambassadeurs Fodindin', text: "Devenez le relais de la solidarit\u00e9 dans votre communaut\u00e9. Soutenez, partagez et amplifiez l'impact des cagnottes autour de vous.", color: '#d97757' },
  { id: 'cercles', Icon: Building2, label: 'Cercles', badge: 'B2B', title: 'Cercles Fodindin \u00b7 Entreprises', text: 'Rassemblez vos \u00e9quipes autour d\'\u00e9v\u00e9nements solidaires : mariages, obs\u00e8ques, cadeaux group\u00e9s. Un espace priv\u00e9 pour votre organisation.', color: '#5a8268' },
  { id: 'bourses', Icon: GraduationCap, label: 'Bourses', badge: 'NOUVEAU', title: 'Bourses solidaires', text: "Un fonds abond\u00e9 par Fodindin qui compl\u00e8te automatiquement les cagnottes \u00e9tudiantes et \u00e9ducatives \u00e9ligibles.", color: '#d97757' },
  { id: 'foundations', Icon: HandCoins, label: 'Foundations', badge: 'PRO', title: 'Fondations & Associations', text: 'Un espace d\u00e9di\u00e9 aux fondations et associations pour collecter, tracer et publier leurs campagnes de solidarit\u00e9.', color: '#5a8268' },
  { id: 'crisis', Icon: Radio, label: 'Crisis', badge: 'LIVE', title: 'Crisis Response', text: "Un dispositif d'urgence activ\u00e9 pour les crises humanitaires (inondations, s\u00e9cheresse, sinistres). R\u00e9ponse rapide et coordonn\u00e9e.", color: '#d97757' },
  { id: 'saisons', Icon: CalendarDays, label: 'Saisons', badge: 'NOUVEAU', title: 'Saisons Fodindin', text: 'Des temps forts de l\'ann\u00e9e o\u00f9 Fodindin bonifie les cagnottes : Hivernage, Tabaski, Rentr\u00e9e scolaire, F\u00eates de fin d\'ann\u00e9e...', color: '#5a8268' },
];

const BadgeChip = ({ label }) => {
  const color = label === 'LIVE' ? 'bg-rose-500 text-white' : label === 'B2B' ? 'bg-sky-600 text-white' : label === 'PRO' ? 'bg-amber-500 text-black' : 'bg-emerald-600 text-white';
  return (
    <span className={`ml-1.5 text-[9.5px] tracking-wider font-bold px-1.5 py-0.5 rounded ${color}`}>{label}</span>
  );
};

export default function ProgramsSection() {
  return (
    <section className="relative">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 pb-20">
        <div className="text-[11px] tracking-[0.18em] uppercase font-medium text-neutral-500">Programmes Fodindin</div>
        <h2 className="mt-2 text-[clamp(2rem,4vw,3.4rem)] leading-[1.05] font-semibold tracking-tight text-[#1a1d1a]">
          Une solidarité <span className="serif-italic text-[#5a8268]">à grande échelle</span>
        </h2>
        <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {placeholders.map(p => (
            <div id={p.id} key={p.id} className="scroll-mt-24 rounded-3xl bg-white border border-black/5 p-6 card-lift">
              <div className="flex items-start justify-between">
                <div className="w-11 h-11 rounded-xl flex items-center justify-center" style={{ background: `${p.color}18`, color: p.color }}>
                  <p.Icon className="w-5 h-5" />
                </div>
                <div className="flex items-center">
                  <span className="text-[11px] uppercase tracking-wider text-neutral-500">{p.label}</span>
                  {p.badge && <BadgeChip label={p.badge} />}
                </div>
              </div>
              <h3 className="mt-4 text-[17px] font-semibold text-[#1a1d1a] leading-tight">{p.title}</h3>
              <p className="mt-2 text-[13.5px] text-neutral-600 leading-relaxed">{p.text}</p>
              <div className="mt-4 inline-flex items-center gap-1 text-[12.5px] text-neutral-500">
                <span className="px-2 py-0.5 rounded-full bg-amber-100 text-amber-800 text-[10.5px] font-semibold tracking-wide uppercase">Bientôt</span>
                <span>Nous vous informerons du lancement</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
